import React from "react"

export function Delete(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_2_3472)">
        <path
          d="M3.69687 0.483984C3.84453 0.185938 4.14805 0 4.47891 0H7.77109C8.10195 0 8.40547 0.185938 8.55312 0.483984L8.75 0.875H11.375C11.859 0.875 12.25 1.26602 12.25 1.75C12.25 2.23398 11.859 2.625 11.375 2.625H0.875C0.391016 2.625 0 2.23398 0 1.75C0 1.26602 0.391016 0.875 0.875 0.875H3.5L3.69687 0.483984ZM0.875 3.5H11.375V12.25C11.375 13.2152 10.5902 14 9.625 14H2.625C1.65977 14 0.875 13.2152 0.875 12.25V3.5ZM3.5 5.25C3.25938 5.25 3.0625 5.44688 3.0625 5.6875V11.8125C3.0625 12.0531 3.25938 12.25 3.5 12.25C3.74062 12.25 3.9375 12.0531 3.9375 11.8125V5.6875C3.9375 5.44688 3.74062 5.25 3.5 5.25ZM6.125 5.25C5.88438 5.25 5.6875 5.44688 5.6875 5.6875V11.8125C5.6875 12.0531 5.88438 12.25 6.125 12.25C6.36562 12.25 6.5625 12.0531 6.5625 11.8125V5.6875C6.5625 5.44688 6.36562 5.25 6.125 5.25ZM8.75 5.25C8.50937 5.25 8.3125 5.44688 8.3125 5.6875V11.8125C8.3125 12.0531 8.50937 12.25 8.75 12.25C8.99063 12.25 9.1875 12.0531 9.1875 11.8125V5.6875C9.1875 5.44688 8.99063 5.25 8.75 5.25Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_3472">
          <path d="M0 0H12.25V14H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
